import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const highlights = [
  { icon: FiIcons.FiShield, text: 'Premium Products' },
  { icon: FiIcons.FiAward, text: 'Certified Detailers' },
  { icon: FiIcons.FiStar, text: 'Satisfaction Guarantee' },
  { icon: FiIcons.FiCalendar, text: 'Flexible Scheduling' },
];

const Hero = () => {
  return (
    <div className="relative min-h-[90vh] flex items-center bg-hero-pattern bg-cover bg-center bg-no-repeat bg-fixed">
      <div className="absolute inset-0 bg-gradient-to-r from-bgDark via-bgDark/80 to-transparent"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-20">
        <div className="max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="text-accent font-medium tracking-wider uppercase text-sm mb-4 block">
              Montreal's Elite Auto Spa
            </span>
            <h1 className="text-5xl md:text-7xl font-bold font-heading leading-tight mb-6">
              Premium Detailing That <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent to-yellow-200">Turns Heads.</span>
            </h1>
            <p className="text-lg md:text-xl text-textMuted mb-10 max-w-2xl leading-relaxed">
              Specializing in ceramic coatings, paint correction, interior detailing, and complete vehicle transformations. We don't just clean cars; we restore their soul.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 mb-16">
              <Link to="/booking" className="btn-primary text-lg px-8 py-4">
                Book Appointment
              </Link>
              <Link to="/contact" className="btn-outline text-lg px-8 py-4 border-white/20 text-textLight hover:border-accent hover:text-black">
                Get a Quote
              </Link>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-8 border-t border-white/10">
              {highlights.map((item, idx) => (
                <div key={idx} className="flex items-center gap-3">
                  <div className="bg-accent/10 p-2 rounded-lg">
                    <SafeIcon icon={item.icon} className="text-accent text-xl" />
                  </div>
                  <span className="text-sm font-medium text-textLight">{item.text}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Hero;